// import './vendor.js';
import './../sass/style.scss';
import 'bootstrap';
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import Flickity from 'flickity';
import 'lightgallery/dist/js/lightgallery-all';

//import noUiSlider from 'nouislider';

//import wNumb from './wnumb-1.1.0/wNumb';

import 'lazysizes/lazysizes.min.js';

//import 'isotope-layout/dist/isotope.pkgd.js';
//import 'imagesloaded/imagesloaded.pkgd.js';

fontawesome.library.add(light);

jQuery(function ($) {
	"use strict";

	//radio js vor checked
	function setSalutationState(){
	    $('.complex-form-gender-fm input, .complex-form-gender-m input').each(function(key, elem){
	        if (elem.checked) {
	            $(elem).closest('div').addClass('checked');
	        } else {
	            $(elem).closest('div').removeClass('checked');
	        }
	    });
	}

	function setRadioBtnsPlease(){
		$(".complex-contact-form .radio label").each(function(index, elem){
    		var isChecked = $(elem).find("input[type='radio']").is(":checked");
	    	if (isChecked) {
	    		$(".complex-contact-form .radio label").removeClass("checked");
	    		$(elem).addClass("checked");
	    	} else {
	    		$(".complex-contact-form .radio label").addClass("checked");
	    		$(elem).removeClass("checked");
	    	}
    	});
	}

	function isScrolledIntoView(elem) {
	    var docViewTop = $(window).scrollTop();
	    var docViewBottom = docViewTop + $(window).height();

	    var elemTop = $(elem).offset().top;
	    var elemBottom = elemTop + $(elem).height();

	    return ((elemTop <= (docViewTop + $(window).height())));
	}
	function revealElements() {
		$('.reveal').each(function () {
		var $revealElement = $(this);
		if (isScrolledIntoView($revealElement) === true) {
	   		if ($revealElement.data('delay')) {
	        	setTimeout(function(){
	            	$($revealElement).addClass('revealed');
	       		}, $revealElement.data('delay'));
	        } else {
                setTimeout(function(){
                    $($revealElement).addClass('revealed');
                }, 0);
            }
	        }
	    });
	}


	revealElements();
	$(window).on('scroll', function(){
	    revealElements();
	});

	setRadioBtnsPlease();
    $(".complex-contact-form .radio label").on('click', function(){
    	setRadioBtnsPlease();
    })

	$('.complex-form-gender-fm input, .complex-form-gender-m input').on('change', function(){
		setSalutationState();
	});
	setSalutationState();
	
	$('.galleryRow').lightGallery({
	    selector: '.custom-selector'
	});

	$('.navbar-toggler').on('click', function(){
		if ($(this).hasClass('active-nav')) {
			$(this).removeClass('active-nav');
			$('.navbarOuter').removeClass('nav-bg');
		} else {
			$(this).addClass('active-nav');
			$('.navbarOuter').addClass('nav-bg');
		}
	});

	$('.navbar-collapse').on('shown.bs.collapse', function(){
		/*$('#footer').hide();
		$('#content').hide();
		$('.sliderOuter').hide();*/
		$('.navbar-toggler').removeClass('dontClick');
	});

	$('.navbar-collapse').on('show.bs.collapse', function(){
		$('.navbar-toggler').addClass('dontClick');
	});

	$('.navbar-collapse').on('hidden.bs.collapse', function(){
		$('.navbar-toggler').removeClass('dontClick');
	});

	$('.navbar-collapse').on('hide.bs.collapse', function(){
		/*$('#footer').show();
		$('#content').show();
		$('.sliderOuter').show();*/
		$('.navbar-toggler').addClass('dontClick');
	});

	if ($('.contentSlider').length) {
		var flky = new Flickity( '.contentSlider', {
			cellAlign: 'left',
			contain: true,
			imagesLoaded: true,
			prevNextButtons: true,
			pageDots: false,
			draggable: false,
			arrowShape: 'M7.9948243,51 L25.6594402,67.871693 C26.0588254,68.2531507 26.0733584,68.8861488 25.6919008,69.285534 C25.3104431,69.6849191 24.6774449,69.6994522 24.2780598,69.3179945 L4.80930978,50.7231508 C4.39689674,50.32925 4.39689674,49.67075 4.80930978,49.2768492 L24.2780598,30.6820055 C24.6774449,30.3005478 25.3104431,30.3150809 25.6919008,30.714466 C26.0733584,31.1138512 26.0588254,31.7468493 25.6594402,32.128307 L7.9948243,49 L95,49 C95.5522847,49 96,49.4477153 96,50 C96,50.5522847 95.5522847,51 95,51 L7.9948243,51 Z'
		});
		window.addEventListener( 'load', function() {
		  flky.resize();
		});
	}

	if ($('.bigSlider').length) {
		var big = new Flickity( '.bigSlider', {
			cellAlign: 'left',
			contain: true,
			imagesLoaded: true,
			prevNextButtons: true,
			pageDots: false,
			draggable: false,
			arrowShape: 'M7.9948243,51 L25.6594402,67.871693 C26.0588254,68.2531507 26.0733584,68.8861488 25.6919008,69.285534 C25.3104431,69.6849191 24.6774449,69.6994522 24.2780598,69.3179945 L4.80930978,50.7231508 C4.39689674,50.32925 4.39689674,49.67075 4.80930978,49.2768492 L24.2780598,30.6820055 C24.6774449,30.3005478 25.3104431,30.3150809 25.6919008,30.714466 C26.0733584,31.1138512 26.0588254,31.7468493 25.6594402,32.128307 L7.9948243,49 L95,49 C95.5522847,49 96,49.4477153 96,50 C96,50.5522847 95.5522847,51 95,51 L7.9948243,51 Z'
		});
		window.addEventListener( 'load', function() {
		  big.resize();
		});
	}

});



// WEBPACK FOOTER //
// ./src/js/main.js